var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarrito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,8L12,3L2.1803589,2.0935669L1.9477539,0H0v1h1.0522461L1.953064,9.1067505  C1.3963623,9.3261108,1,9.866272,1,10.5C1,11.3271484,1.6728516,12,2.5,12S4,11.3271484,4,10.5  c0-0.1761475-0.0360718-0.3428345-0.0921021-0.5h4.1842041C8.0360718,10.1571655,8,10.3238525,8,10.5  C8,11.3271484,8.6728516,12,9.5,12s1.5-0.6728516,1.5-1.5S10.3271484,9,9.5,9H2.9476318l-0.111145-1H11.5z M2.5,11  C2.2241211,11,2,10.7758789,2,10.5c0-0.2634277,0.2062378-0.473938,0.4649048-0.4929199l0.0452881-0.0050049  C2.7811279,10.0078125,3,10.2277222,3,10.5C3,10.7758789,2.7758789,11,2.5,11z M10,10.5c0,0.2758789-0.2241211,0.5-0.5,0.5  S9,10.7758789,9,10.5S9.2241211,10,9.5,10S10,10.2241211,10,10.5z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrito);
export default __webpack_public_path__ + "static/media/carrito.1407243cb231bc44efd204243cbf82a9.svg";
export { ForwardRef as ReactComponent };